import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import pretty from "Shared/pretty";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import DPBackArrow from "Components/DP/DPBackArrow/DPBackArrow";
import useStyles from "./styles";

type Props = {
  firstName: string;
  lastName: string;
  balance: number;
  hasMultipleProviders: boolean;
};

const UserProfileHeader = ({
  firstName,
  lastName,
  balance,
  hasMultipleProviders
}: Props) => {
  const classes = useStyles();
  return (
    <Grid container id="user-profile-header" className={classes.container}>
      <Grid item>
        <DPBackArrow to={InternalRoutes.users} />
      </Grid>
      <Grid item>
        <Typography className={classes.name} variant="h1">
          {firstName} {lastName}
        </Typography>
      </Grid>
      <Grid item className={classes.availableBalance}>
        <b>|</b>
        <Typography className={classes.balanceText} display="inline">
          AVAILABLE BALANCE:
        </Typography>
        <Typography
          color="primary"
          className={classes.balanceAmount}
          display="inline"
        >
          {pretty.dollar(balance)}
        </Typography>
        {hasMultipleProviders && (
          <Typography color="primary" display="inline">
            (combined balance from multiple companies)
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default UserProfileHeader;
